import axios, { type AxiosInstance } from "axios";
import { apiBaseUrl } from "../auth/authConfig";
import { getEnv } from "../hooks/useEnv";
import logger from "../analytics/logger";

let getToken: () => string | undefined = () => undefined;

export function registerTokenSource(fn: () => string | undefined) {
  getToken = fn;
}

function newClient(): AxiosInstance {
  const c = axios.create({ baseURL: apiBaseUrl(getEnv()) });
  c.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // Re-resolve baseURL on every request so env switches take effect without
    // recreating the axios instance.
    config.baseURL = apiBaseUrl(getEnv());
    return config;
  });
  c.interceptors.response.use(
    (r) => r,
    (err) => {
      logger.error("api_request_failed", err, {
        url: err?.config?.url,
        status: err?.response?.status,
      });
      return Promise.reject(err);
    },
  );
  return c;
}

export const api = newClient();
